module.exports = __webpack_public_path__ + "static/media/GM6.aa5c8105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GM6.jpg
// module id = 1153
// module chunks = 0